import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import DeviceCheck from './mobileDeviceZoom.js';
import './custom.css';
import { ShoppingCartProvider } from './components/dealer/ShoppingCartContext';
DeviceCheck();
export default class App extends Component {
    static displayName = App.name;
  render() {
      return (
          <ShoppingCartProvider>
              <Layout>
                  <Routes>
                      {AppRoutes.map((route, index) => {
                          const { element, ...rest } = route;
                          return <Route key={index} {...rest} element={element} />;
                      })}
                  </Routes>
              </Layout>
        </ShoppingCartProvider>
     
    );
  }
}
